import { computed } from 'vue'
import DOMPurify from 'dompurify'
import { MdIconArrowLong, MdButton } from '@antiqua-dls/vue-components'
import { useFetchCMS } from 'src/composables/useFetchCMS'
import Misc from 'src/utils/helper/misc'
import * as Common from 'src/utils/constants/common'

import ReadmoreIcon from '../../icons/readmore-icon/index.vue'
import { adobeCjaEventEmitter } from '../../../../../../modules/adobe-cja/utils'
import { CJA_EVENTS, LINK_CATEGORIES, LINK_SECTION, LINK_TYPES, LINK_NAMES } from '../../../../../../modules/adobe-cja/constants'

export default{
  components:{
    ReadmoreIcon,
    MdIconArrowLong,
    MdButton
  },
  setup(){
    const { data, loading, error, cmsConfig, getCmsData } = useFetchCMS()
    const getCompleteURL = (url, dimension) => `${cmsConfig.domainURL}cdn-cgi/image/width=${dimension.width},height=${dimension.height},fit=contain,format=auto${url}`
    const sanitize = (url) => {
      return DOMPurify.sanitize(url)
    }
    const mainArticles = computed(() => data?.value?.data?.highlight_media_types.slice(0, 3))
    const secondaryArticles = computed(() => data?.value?.data?.highlight_media_types.slice(3))
    const sanitizedUrl = (url) => sanitize(url)
    getCmsData(cmsConfig.articlesAndVideos)
    const getBackgoundImage = (url, dimension)=>({backgroundImage: `url(${getCompleteURL(url, dimension)})`})
    
    const extractUrlSlug = (url) => {
      try {
        const segments = url.split('/')
        const slug = segments[segments.length - 1] || url
        return slug.replace(/-/g, ' ')
      } catch (error) {
        return url
      }
    }
    
    const redirectToCMSPage = (url, type) => {
      const urlSlug = extractUrlSlug(url)
      adobeCjaEventEmitter({
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: type === 'video' ? LINK_CATEGORIES.VIDEO : LINK_CATEGORIES.ARTICLE,
          linkSection: LINK_SECTION.DASHBOARD,
          linkName: type === 'video' ? `${LINK_NAMES.WATCH_NOW} - {${urlSlug}}` : `${LINK_NAMES.READ_NOW} - {${urlSlug}}`,
          linkType: LINK_TYPES.BUTTON
        }
      })
      window.open(url)
    }
    return{
      data,
      loading,
      error,
      mainArticles,
      secondaryArticles,
      getCompleteURL,
      getBackgoundImage,
      redirectToCMSPage,
      Misc,
      sanitize,
      sanitizedUrl,
      Common,
      extractUrlSlug
    }
  }
}
